import { render, staticRenderFns } from "./siteProductInquiryShow.vue?vue&type=template&id=018e6c5e"
import script from "./siteProductInquiryShow.vue?vue&type=script&lang=js"
export * from "./siteProductInquiryShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018e6c5e')) {
      api.createRecord('018e6c5e', component.options)
    } else {
      api.reload('018e6c5e', component.options)
    }
    module.hot.accept("./siteProductInquiryShow.vue?vue&type=template&id=018e6c5e", function () {
      api.rerender('018e6c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/child/siteProductInquiryShow.vue"
export default component.exports